//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { RoomGroupModel } from '@app/catalog';
import { PresenterType } from '@app/shared';



@PresenterType({
  model: RoomGroupModel,
  key: 'tileTop'
})
@Component({
  selector: 'room-group-carousel-item',
  standalone: false,
  templateUrl: './room-group-carousel-item.component.html',
  styleUrl: './room-group-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomGroupCarouselItemComponent {
  public data: WritableSignal<RoomGroupModel> = signal<RoomGroupModel>(undefined);
}
